import React, { useCallback, useEffect, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { arrowForwardCircle } from 'ionicons/icons';
import CarouselItem from './CarouselItem';
import { SectionTitle } from '../../Global/styles';
import {
	CarouselContainer,
	CarouselHeader,
	CarouselMeta,
	CarouselSwiper,
	CarouselSwiperSlide,
	MoreResultsCard,
	ProgressBar,
	ProgressInner,
} from './carouselStyles';
import 'swiper/css';
import 'swiper/css/free-mode';
import { PlaceList } from '../../../models/factories/PlaceFactory';
import { Link } from 'react-router-dom';

type CarouselProps = {
	places: PlaceList;
	title?: string;
	viewAllTo?: string;
};

const FilteredCarousel: React.FC<CarouselProps> = ({
	places,
	title,
	viewAllTo,
}) => {
	const [swiper, setSwiper] = useState({ realIndex: 0 });
	const [progress, setProgress] = useState('');
	const items = places.places;

	const handleSlideChange = () => {
		calculateTotalProgress();
	};

	const calculateTotalProgress = useCallback(() => {
		const total = items.length;
		const currentProgress = swiper.realIndex + 1;
		const currentPercentage = 100 / (total / currentProgress);
		setProgress(`${currentPercentage}%`);
	}, [items.length, swiper.realIndex]);

	useEffect(() => {
		if (items.length === 0) return;
		calculateTotalProgress();
	}, [items, calculateTotalProgress]);

	return (
		<CarouselContainer>
			<CarouselHeader>
				<div>
					<SectionTitle>{title ?? 'Filtered carousel'}</SectionTitle>
					<CarouselMeta>
						{`${
							items.length > 1
								? `${items.length} Places`
								: `${items.length} Place`
						}`}
					</CarouselMeta>
				</div>
				{viewAllTo && (
					<Link to={viewAllTo}>
						<IonIcon icon={arrowForwardCircle}></IonIcon>
					</Link>
				)}
			</CarouselHeader>

			<CarouselSwiper
				slidesPerView={'auto'}
				spaceBetween={8}
				// freeMode={true}
				// modules={ [FreeMode] }
				className="carousel-swiper"
				onSlideChange={() => handleSlideChange()}
				onSwiper={(swiper) => setSwiper(swiper)}>
				{items.map((item) => (
					<CarouselSwiperSlide key={item.id}>
						<CarouselItem item={item} />
					</CarouselSwiperSlide>
				))}

				{viewAllTo && (
					<CarouselSwiperSlide className="swiper-more-results">
						<Link to={viewAllTo}>
							<MoreResultsCard>
								<IonIcon icon={arrowForwardCircle}></IonIcon>
							</MoreResultsCard>
						</Link>
					</CarouselSwiperSlide>
				)}
			</CarouselSwiper>

			<ProgressBar>
				<ProgressInner $progress={progress} />
			</ProgressBar>
		</CarouselContainer>
	);
};

export default FilteredCarousel;
